module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "uk-padding"
  }, [_c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/blog"
    }
  }, [_vm._v("Blog")])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "uk-align-left"
  }, [_vm._v("Blog")]), _vm._v(" "), _c('div', {
    staticClass: "uk-align-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'EditBlogPost',
        params: {
          id: 0
        }
      },
      "uk-toggle": "",
      "uk-icon": "icon: plus; ratio: 2"
    }
  })], 1), _vm._v(" "), _c('table', {
    staticClass: "uk-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.blogposts), function(p, id) {
    return _c('tr', [_vm._m(1, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.title))]), _vm._v(" "), (p.category) ? _c('td', [_vm._v(_vm._s(p.category))]) : (p.categories) ? _c('td', _vm._l((p.categories), function(c) {
      return _c('span', [_vm._v(_vm._s(c) + " - ")])
    })) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.convertDate(p.lastEdit)))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "uk-link",
      attrs: {
        "to": {
          name: 'EditBlogPost',
          params: {
            id: id
          }
        },
        "uk-icon": "icon: cog"
      }
    })], 1), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "uk-link",
      attrs: {
        "uk-icon": "icon: trash"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(id)
        }
      }
    })])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Naam")]), _vm._v(" "), _c('th', [_vm._v("Categorie")]), _vm._v(" "), _c('th', [_vm._v("Laatste update")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    attrs: {
      "uk-icon": "icon: bolt; ratio: 1.2"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0f3883a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/modules/BLOG/Overview.vue
// module id = 525
// module chunks = 1